<ng-template [ngIf]="loading">
	<div id="overlay" [attr.style]="style">
		<div class="w-100 d-flex justify-content-center align-items-center">
			<div [style]="spinStyle" class="spinner" [style.width.px]="w" [style.height.px]="h" [style.font-size.px]="f"></div>
			<div>
				<div class="h4">{{ text }}</div>
			</div>
		</div>
	</div>
</ng-template>
